import { Controller } from "@hotwired/stimulus"

/**
 * Confirm Submit Controller
 *
 * Shows a confirmation dialog before submitting a form.
 * Use this for bulk delete buttons that need confirmation before form submission.
 *
 * Usage:
 *   <button data-controller="confirm-submit"
 *           data-confirm-submit-form-value="#destroy-multi-form"
 *           data-confirm-submit-message-value="Are you sure?"
 *           data-action="click->confirm-submit#submit">
 *     Delete Selected
 *   </button>
 */
export default class extends Controller {
  static values = {
    form: String,
    message: String
  }

  submit(event) {
    event.preventDefault()

    const message = this.messageValue || "Are you sure?"

    if (confirm(message)) {
      const form = document.querySelector(this.formValue)
      if (form) {
        form.submit()
      } else {
        console.error(`Form not found: ${this.formValue}`)
      }
    }
  }
}
